// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Compat (mobile) */

@media (width <= /* \$screen-sm - 0.02 */ 425.98px) {
  .bc-table {
    grid-template-columns: auto;

    thead {
      display: none;
    }

    tr {
      td.bc-support {
        display: block;
        border: none;
        border-top: 1px solid var(--compat-border-primary);

        &:last-child {
          border-bottom: 1px solid var(--compat-border-primary);
        }
      }
    }

    .timeline {
      /* Align timeline icons with summary icon. */
      margin-left: 0.25rem;
    }

    tr:not(:first-of-type) .bc-feature {
      /* Feature separator. */
      border-top: 2px solid var(--compat-border-primary);
    }

    .bc-feature,
    .bc-support > button {
      display: flex;

      flex-wrap: wrap;

      gap: 0.5rem;
      align-content: center;
    }
  }

  .bc-on-github a {
    white-space: nowrap;
  }

  .table-container {
    overflow-x: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./components/compat/index-mobile.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB;EACE;IACE,2BAA2B;;IAE3B;MACE,aAAa;IACf;;IAEA;MACE;QACE,cAAc;QACd,YAAY;QACZ,kDAAkD;;QAElD;UACE,qDAAqD;QACvD;MACF;IACF;;IAEA;MACE,4CAA4C;MAC5C,oBAAoB;IACtB;;IAEA;MACE,uBAAuB;MACvB,kDAAkD;IACpD;;IAEA;;MAEE,aAAa;;MAEb,eAAe;;MAEf,WAAW;MACX,qBAAqB;IACvB;EACF;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Compat (mobile) */\n\n@media (width <= /* $screen-sm - 0.02 */ 425.98px) {\n  .bc-table {\n    grid-template-columns: auto;\n\n    thead {\n      display: none;\n    }\n\n    tr {\n      td.bc-support {\n        display: block;\n        border: none;\n        border-top: 1px solid var(--compat-border-primary);\n\n        &:last-child {\n          border-bottom: 1px solid var(--compat-border-primary);\n        }\n      }\n    }\n\n    .timeline {\n      /* Align timeline icons with summary icon. */\n      margin-left: 0.25rem;\n    }\n\n    tr:not(:first-of-type) .bc-feature {\n      /* Feature separator. */\n      border-top: 2px solid var(--compat-border-primary);\n    }\n\n    .bc-feature,\n    .bc-support > button {\n      display: flex;\n\n      flex-wrap: wrap;\n\n      gap: 0.5rem;\n      align-content: center;\n    }\n  }\n\n  .bc-on-github a {\n    white-space: nowrap;\n  }\n\n  .table-container {\n    overflow-x: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
